import { registerComponent } from '@gig/magic-common';
import PromotionComponent from './promotion.vue.js';

var Promotion = registerComponent(PromotionComponent);

export { Promotion };
